import * as React from 'react';

export const ShieldIcon = (props:{ height?:number }) => {

  const height = props.height ? props.height : 24;
  const width = height * 5 / 6;

  return (
    <svg width={width} height={height} viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path id="shield"
            d="M10 24C7.10417 23.3 4.71354 21.705 2.82812 19.215C0.942708 16.725 0 13.96 0 10.92V3.6L10 0L20 3.6V10.92C20 13.96 19.0573 16.725 17.1719 19.215C15.2865 21.705 12.8958 23.3 10 24ZM10 21.48C12.1667 20.82 13.9583 19.5 15.375 17.52C16.7917 15.54 17.5 13.34 17.5 10.92V5.25L10 2.55L2.5 5.25V10.92C2.5 13.34 3.20833 15.54 4.625 17.52C6.04167 19.5 7.83333 20.82 10 21.48Z"
            fill="url(#paint0_linear_10169_2079)"/>
      <defs>
        <linearGradient id="paint0_linear_10169_2079" x1="0" y1="0" x2="24.9892" y2="7.60404"
                        gradientUnits="userSpaceOnUse">
          <stop offset="0.0174872" stopColor="#7D2E68"/>
          <stop offset="1" stopColor="#003595"/>
        </linearGradient>
      </defs>
    </svg>
  );
}